export default {
    SET_USER: 'SET_USER',
    SET_AUTHENTICATION: 'SET_AUTHENTICATION',
    SET_APPOINTMENTS: 'SET_APPOINTMENTS',
    SET_BOOKING_PAGE_URL: 'SET_BOOKING_PAGE_URL'
};
